<template>
  <div class="container-fluid im-fluid" @click="$root.hideMenu">
    <div class="row">
      <div class="col-12 col-sm-12 col-lg-6 col-xl-4 border-right">
        <div class="im-col im-col-1">
          <div class="im-block">
            <h2 class="im-title">{{ $t("home.title") }}</h2>
            <p>
              {{ $t("home.intro_text", { companyYear }) }}
            </p>
            <p>
              {{ $t("home.services_intro") }}
            </p>
            <ul>
              <li class="mb-4">
                {{ $t("services.business_analysis") }}
              </li>
              <li class="mb-4">
                {{ $t("home.service_project_management") }}
              </li>
              <li class="mb-4">
                {{ $t("home.service_development") }}
              </li>
            </ul>
            <p>
              <router-link to="/services" @click.stop.prevent="$root.gotoServices">{{
                $t("home.more_about")
              }}</router-link
              ><br />
              <router-link to="/clients" @click.stop.prevent="$root.gotoClients">{{
                $t("nav.clients")
              }}</router-link>
            </p>
            <p>
              {{ $t("home.we_work_with") }}<br />
              {{ $t("home.tech_stack") }}
            </p>
            <p>
              <router-link
                to="/contact-us"
                class="btn btn-primary btn-block"
                @click.stop.prevent="$root.gotoContactUs"
              >
                {{ $t("contact.title") }}
              </router-link>
            </p>
          </div>
          <div class="im-block">
            <h2 class="im-title">{{ $t("home.team_title") }}</h2>
            <div class="im-team">
              <div class="im-person">
                <img
                  :src="$img('team/avatar-krasimir.png')"
                  :title="$root.avatarFullName(0)"
                  class="rounded"
                  alt
                />
                <span v-html="$root.avatarName(0)"></span>
              </div>
              <div class="im-person">
                <img
                  :src="$img('team/avatar-nikolay.png')"
                  :title="$root.avatarFullName(1)"
                  class="rounded"
                  alt
                />
                <span v-html="$root.avatarName(1)"></span>
              </div>
              <div class="im-person">
                <img
                  :src="$img('team/avatar-plamen.png')"
                  :title="$root.avatarFullName(2)"
                  class="rounded"
                  alt
                />
                <span v-html="$root.avatarName(2)"></span>
              </div>
              <div class="im-person">
                <img
                  :src="$img('team/avatar-angel.png')"
                  :title="$root.avatarFullName(3)"
                  class="rounded"
                  alt
                />
                <span v-html="$root.avatarName(3)"></span>
              </div>
              <div class="im-person">
                <img
                  :src="$img('team/avatar-dimitar.png')"
                  :title="$root.avatarFullName(4)"
                  class="rounded"
                  alt
                />
                <span v-html="$root.avatarName(4)"></span>
              </div>
              <div class="im-person">
                <img
                  :src="$img('team/avatar-milen.png')"
                  :title="$root.avatarFullName(5)"
                  class="rounded"
                  alt
                />
                <span v-html="$root.avatarName(5)"></span>
              </div>
              <div class="im-person">
                <img
                  :src="$img('team/avatar-ivo.png')"
                  :title="$root.avatarFullName(7)"
                  class="rounded"
                  alt
                />
                <span v-html="$root.avatarName(7)"></span>
              </div>
              <div class="im-person">
                <img
                  :src="$img('team/avatar-simona.png')"
                  :title="$root.avatarFullName(6)"
                  class="rounded"
                  alt
                />
                <span v-html="$root.avatarName(6)"></span>
              </div>
              <div class="im-person">
                <img
                  :src="$img('team/avatar-salih.png')"
                  :title="$root.avatarFullName(8)"
                  class="rounded"
                  alt
                />
                <span v-html="$root.avatarName(8)"></span>
              </div>
              <div class="im-person">
                <img
                  :src="$img('team/avatar-viktor.png')"
                  :title="$root.avatarFullName(9)"
                  class="rounded"
                  alt
                />
                <span v-html="$root.avatarName(9)"></span>
              </div>
              <div class="im-person">
                <router-link to="/job-application" @click.stop.prevent="$root.gotoJobApplication">
                  <img
                    :src="$img('team/avatar-plus.png')"
                    :alt="$t('job.submit_cv')"
                    class="rounded"
                  />
                  <span>{{ $t("job.submit_cv") }}</span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-lg-6 col-xl-4 border-right">
        <div class="im-col im-col-2">
          <div class="im-block">
            <h2 class="im-title">{{ $t("home.partnerships_title") }}</h2>
            <p>
              {{ $t("home.partnerships_intro") }}
            </p>
            <p>
              {{ $t("home.partnerships_choose") }}
            </p>
            <p>
              <router-link
                to="/partnership-entrepreneur"
                class="btn btn-primary btn-block btn-long-text"
                @click.stop.prevent="$root.gotoPartnershipEntrepreneur"
              >
                {{ $t("home.entrepreneur_button_line1")
                }}<br class="d-none lv-d-xs-block d-lg-block d-xl-none" />
                {{ $t("home.entrepreneur_button_line2") }}
              </router-link>
            </p>
            <p>
              <router-link
                to="/partnership-programmer"
                class="btn btn-primary btn-block btn-long-text"
                @click.stop.prevent="$root.gotoPartnershipProgrammer"
              >
                <span class="d-none d-xxl-block">{{ $t("home.programmer_button_long") }}</span>
                <span class="d-xxl-none"
                  >{{ $t("home.programmer_button_line1")
                  }}<br class="d-none lv-d-xs-block d-lg-block d-xl-none" />
                  {{ $t("home.programmer_button_line2") }}</span
                >
              </router-link>
            </p>
          </div>
          <div class="im-block">
            <h2 class="im-title">{{ $t("home.our_projects") }}</h2>
            <div class="im-project" @click.stop.prevent="$root.gotoProjects">
              <img :src="$img('projects/lv-logo.svg')" />
            </div>
            <div class="im-project" @click.stop.prevent="$root.gotoProjects">
              <img :src="$img('projects/aikidesk-logo.png')" />
            </div>
            <p>
              <router-link to="/projects" @click.stop.prevent="$root.gotoProjects">{{
                $t("home.more_projects")
              }}</router-link>
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-xl-4">
        <div class="im-col im-col-3">
          <div class="im-block">
            <h2 class="im-title">{{ $t("home.work_training_title") }}</h2>
            <p>
              {{ $t("home.training_intro") }}
            </p>
            <ul>
              <li class="mb-4">
                {{ $t("home.training_programming_basics") }}
              </li>
              <li class="mb-4">
                {{ $t("home.training_oop") }}
              </li>
              <li class="mb-4">
                {{ $t("home.training_clean_code") }}
              </li>

              <li class="mb-4">
                {{ $t("home.training_php_laravel") }}
              </li>
              <li class="mb-4">
                {{ $t("home.training_databases") }}
              </li>
              <li class="mb-4">
                {{ $t("home.training_tools") }}
              </li>
            </ul>
            <p>
              <router-link
                to="/training-and-mentoring-program"
                @click.stop.prevent="$root.gotoTrainingAndMentoringProgram"
                >{{ $t("home.more_training") }}</router-link
              ><br />
              <router-link
                to="/self-learning-resources"
                @click.stop.prevent="$root.gotoSelfLearningResources"
                >{{ $t("nav.self_learning") }}</router-link
              >
            </p>
          </div>
          <div class="im-block">
            <h2 class="im-title">{{ $t("home.free_positions_title") }}</h2>
            <router-link to="/job-application" @click.stop.prevent="$root.gotoJobApplication(2)">{{
              $t("home.position_laravel")
            }}</router-link>
            <br />
            <router-link to="/job-application" @click.stop.prevent="$root.gotoJobApplication(1)">{{
              $t("home.position_symfony")
            }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "HomeSection",
    computed: {
      companyYear: function () {
        return new Date().getFullYear() - 2001;
      },
    },
  };
</script>
